/* eslint-disable react/no-unescaped-entities */
import { Link } from 'react-router-dom';

const EFFECTIVE_DATE = 'December 17, 2025';

export default function Terms() {
  return (
    <div className="hp-legal">
      <header className="hp-legal-header">
        <Link to="/" className="hp-legal-back" data-testid="legal-back">
          ← Back
        </Link>
        <p className="hp-eyebrow">
          <span className="hp-dot" />
          The Hall Pass · Hayward, CA
        </p>
        <h1 className="hp-legal-title">Terms of Service</h1>
        <p className="hp-legal-meta">Effective: {EFFECTIVE_DATE}</p>
      </header>

      <main className="hp-legal-body" data-testid="terms-content">
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            These Terms of Service (the "Terms") form a binding legal agreement
            between you ("you" or "your") and The Hall Pass, including its
            owners, operators, affiliates, parents, subsidiaries, members,
            managers, officers, directors, employees, agents, contractors, and
            representatives (collectively, "The Hall Pass," "we," "us," or
            "our"). The Terms govern your access to and use of our pre-launch
            landing page, reservation list, communications, and any related
            services, websites, content, and materials offered by us in
            connection with the proposed Hall Pass venue and brand in or
            around Hayward, California (collectively, the "Services").
          </p>
          <p>
            By submitting information through our reservation form, providing
            consent to receive communications, or otherwise using the
            Services, you agree to these Terms and to our Privacy Policy. If
            you do not agree, do not use the Services.
          </p>
        </section>

        <section>
          <h2>2. Pre-Launch Nature; No Guarantee</h2>
          <p>
            The Services are a pre-launch interest list. The Hall Pass is not
            yet open. Joining our list does not guarantee admission, entry,
            membership, reservations, tickets, products, services, pricing, or
            availability of any kind. All opening dates, operations,
            programming, pricing, products, services, hours, capacity, and
            policies are subject to change or cancellation at our sole
            discretion, with or without notice, and may be delayed, modified,
            suspended, or never offered. We make no representation, warranty,
            or commitment that we will open, operate, or continue to operate.
          </p>
        </section>

        <section>
          <h2>3. Eligibility</h2>
          <p>
            You represent and warrant that you are at least 21 years of age,
            are a resident of the United States, have the legal capacity to
            enter into these Terms, and will use the Services only for lawful
            purposes consistent with these Terms. If you provide a telephone
            number, you represent and warrant that you are the regular user
            and account holder of that number and that you are authorized to
            consent to receive automated messages on that number.
          </p>
        </section>

        <section>
          <h2>4. Marketing Communications Consent</h2>
          <p>
            When you submit our reservation form with the consent box checked,
            you expressly agree to receive recurring marketing and
            transactional emails and automated text messages (SMS/MMS) from
            The Hall Pass regarding launch updates, reservations, openings,
            events, promotions, and related announcements. Consent is not a
            condition of any purchase. Message and data rates may apply.
            Message frequency may vary. Reply STOP to unsubscribe from texts
            or HELP for help. You may unsubscribe from emails using the link
            in any marketing email.
          </p>
        </section>

        <section>
          <h2>5. Permitted Use</h2>
          <p>You agree not to, and not to attempt to, do any of the following:</p>
          <ul>
            <li>
              Use the Services for any unlawful, deceptive, or fraudulent
              purpose, or in violation of any law, regulation, or right of any
              party.
            </li>
            <li>
              Submit false, misleading, or impersonating information, including
              another person's name, email address, or telephone number
              without authorization.
            </li>
            <li>
              Use bots, scrapers, scripts, automated tools, or other means to
              submit information, harvest data, or interfere with the
              Services.
            </li>
            <li>
              Attempt to reverse-engineer, decompile, probe, scan, or test the
              vulnerability of the Services, or breach any security or
              authentication measures.
            </li>
            <li>
              Interfere with, disrupt, overload, or degrade the Services,
              servers, or networks.
            </li>
            <li>
              Use the Services to send spam, malware, harassment, or unlawful
              content, or to violate any third-party rights.
            </li>
            <li>
              Frame, mirror, or otherwise create derivative works of the
              Services without our prior written consent.
            </li>
          </ul>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            The Services, including all content, designs, copy, graphics,
            logos, marks (including without limitation "The Hall Pass"), trade
            dress, photographs, videos, code, layout, and the selection and
            arrangement thereof, are owned by The Hall Pass or its licensors
            and are protected by U.S. and international copyright, trademark,
            and other intellectual-property laws. Except as expressly
            permitted, you may not reproduce, distribute, publicly display,
            modify, create derivative works of, sell, or otherwise exploit any
            portion of the Services without our prior written consent.
          </p>
          <p>
            Any feedback, suggestions, ideas, or other materials you provide
            to us regarding the Services are non-confidential and may be used
            by us for any purpose without compensation or attribution.
          </p>
        </section>

        <section>
          <h2>7. Third-Party Services</h2>
          <p>
            The Services may rely on or interoperate with third-party
            providers (including email, SMS, hosting, and analytics vendors)
            and may link to third-party websites. We are not responsible for
            third-party services or content and do not endorse them. Use of
            third-party services is governed by the applicable third-party
            terms and privacy policies.
          </p>
        </section>

        <section>
          <h2>8. Disclaimers</h2>
          <p>
            THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS,
            WITH ALL FAULTS, AND WITHOUT WARRANTY OF ANY KIND. TO THE MAXIMUM
            EXTENT PERMITTED BY APPLICABLE LAW, THE HALL PASS DISCLAIMS ALL
            WARRANTIES AND CONDITIONS, EXPRESS, IMPLIED, OR STATUTORY,
            INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
            NON-INFRINGEMENT, ACCURACY, RELIABILITY, AND QUIET ENJOYMENT, AND
            ANY WARRANTIES ARISING FROM COURSE OF DEALING, USAGE, OR TRADE.
            WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, SECURE,
            ERROR-FREE, FREE FROM HARMFUL COMPONENTS, OR THAT INFORMATION YOU
            SUBMIT WILL BE DELIVERED OR RECEIVED. SOME JURISDICTIONS DO NOT
            ALLOW THE EXCLUSION OF CERTAIN WARRANTIES; IN THOSE JURISDICTIONS,
            THE FOREGOING EXCLUSIONS APPLY TO THE MAXIMUM EXTENT PERMITTED.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
            SHALL THE HALL PASS BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
            SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR ANY
            LOSS OF PROFITS, REVENUE, BUSINESS, GOODWILL, DATA, USE, OR OTHER
            INTANGIBLE LOSSES, ARISING OUT OF OR RELATED TO THESE TERMS OR THE
            SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING
            NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, AND WHETHER OR
            NOT THE HALL PASS HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH
            DAMAGE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE
            HALL PASS'S TOTAL CUMULATIVE LIABILITY ARISING OUT OF OR RELATED
            TO THESE TERMS OR THE SERVICES SHALL NOT EXCEED ONE HUNDRED U.S.
            DOLLARS (US $100). THE LIMITATIONS IN THIS SECTION APPLY EVEN IF A
            REMEDY FAILS OF ITS ESSENTIAL PURPOSE. SOME JURISDICTIONS DO NOT
            ALLOW THE LIMITATION OR EXCLUSION OF CERTAIN DAMAGES; IN THOSE
            JURISDICTIONS, OUR LIABILITY IS LIMITED TO THE MAXIMUM EXTENT
            PERMITTED.
          </p>
        </section>

        <section>
          <h2>10. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless The Hall Pass
            and its owners, operators, affiliates, parents, subsidiaries,
            members, managers, officers, directors, employees, agents,
            contractors, licensors, successors, and assigns (the "Indemnified
            Parties") from and against any and all claims, demands, actions,
            proceedings, losses, liabilities, damages, judgments, fines,
            penalties, costs, and expenses (including reasonable attorneys'
            fees and court costs) arising out of or relating to: (a) your
            access to or use of the Services; (b) your violation of these
            Terms, the Privacy Policy, or any applicable law or regulation;
            (c) your violation of any third-party right, including any
            intellectual-property, privacy, publicity, or contractual right;
            (d) any information or content you submit to us, including the
            accuracy or authority of any contact information you provide; or
            (e) your negligent or wrongful conduct. We reserve the right, at
            our own expense, to assume the exclusive defense and control of
            any matter otherwise subject to indemnification by you, in which
            case you agree to cooperate with our defense.
          </p>
        </section>

        <section>
          <h2>11. Privacy</h2>
          <p>
            Your use of the Services is subject to our{' '}
            <Link to="/privacy" className="hp-legal-inline">
              Privacy Policy
            </Link>
            , which is incorporated by reference into these Terms.
          </p>
        </section>

        <section>
          <h2>12. Termination</h2>
          <p>
            We may suspend, restrict, or terminate your access to the Services
            at any time, without notice, for any reason, including if we
            believe you have violated these Terms. You may stop using the
            Services at any time. Sections that by their nature should survive
            termination (including Sections on Intellectual Property,
            Disclaimers, Limitation of Liability, Indemnification, Governing
            Law, Dispute Resolution, and Miscellaneous) will survive.
          </p>
        </section>

        <section>
          <h2>13. Governing Law &amp; Venue</h2>
          <p>
            These Terms and any dispute or claim arising out of or relating to
            them or the Services (including non-contractual disputes or
            claims) are governed by the laws of the State of California,
            without regard to its conflict-of-laws principles. Subject to the
            arbitration provision below, the exclusive venue for any action
            not subject to arbitration shall be the state and federal courts
            located in Alameda County, California, and the parties consent to
            personal jurisdiction therein.
          </p>
        </section>

        <section>
          <h2>14. Dispute Resolution; Binding Arbitration; Class-Action Waiver</h2>
          <p>
            <strong>Please read this section carefully. It affects your
            rights.</strong>
          </p>
          <p>
            Any dispute, claim, or controversy arising out of or relating to
            these Terms or the Services (each, a "Dispute") shall be resolved
            exclusively by final and binding individual arbitration
            administered by JAMS pursuant to its applicable Streamlined or
            Comprehensive Arbitration Rules in effect at the time arbitration
            is commenced. The arbitration shall take place in Alameda County,
            California, or by videoconference, and shall be conducted in
            English. Judgment on the award may be entered in any court of
            competent jurisdiction. The Federal Arbitration Act governs the
            interpretation and enforcement of this arbitration provision.
          </p>
          <p>
            <strong>Class-Action Waiver</strong>: To the maximum extent
            permitted by applicable law, you and The Hall Pass each agree
            that any Dispute will be brought only in an individual capacity,
            and not as a plaintiff or class member in any purported class,
            collective, consolidated, mass, or representative proceeding.
            The arbitrator may not consolidate more than one person's claims
            and may not preside over any form of representative or class
            proceeding.
          </p>
          <p>
            <strong>Small claims</strong>: Either party may bring an
            individual action in small-claims court for Disputes that qualify,
            so long as the action remains in that court and proceeds on an
            individual basis.
          </p>
          <p>
            <strong>Opt-out</strong>: You may opt out of arbitration by
            emailing{' '}
            <a href="mailto:legal@thehallpass.com">legal@thehallpass.com</a>{' '}
            within thirty (30) days of first accepting these Terms with the
            subject line "Arbitration Opt-Out" and including your full name
            and email address. Opting out of arbitration will not affect any
            other provision of these Terms.
          </p>
        </section>

        <section>
          <h2>15. Changes to the Terms</h2>
          <p>
            We may update these Terms from time to time. The "Effective" date
            above indicates when the Terms were last revised. Material changes
            will be communicated as required by law. Your continued use of the
            Services after a change becomes effective constitutes your
            acceptance of the updated Terms.
          </p>
        </section>

        <section>
          <h2>16. Miscellaneous</h2>
          <p>
            <strong>Entire Agreement</strong>: These Terms, together with our
            Privacy Policy, constitute the entire agreement between you and
            The Hall Pass regarding the Services and supersede any prior
            agreements.
          </p>
          <p>
            <strong>Severability</strong>: If any provision of these Terms is
            found unenforceable, the remaining provisions will remain in full
            force and effect.
          </p>
          <p>
            <strong>No Waiver</strong>: Our failure to enforce any provision
            is not a waiver of that provision.
          </p>
          <p>
            <strong>Assignment</strong>: You may not assign or transfer these
            Terms without our prior written consent. We may assign these Terms
            without restriction.
          </p>
          <p>
            <strong>Force Majeure</strong>: We are not liable for any failure
            or delay in performance caused by events beyond our reasonable
            control.
          </p>
          <p>
            <strong>Notices</strong>: We may provide notices to you by email,
            by posting on the Services, or by other reasonable means. You may
            provide notices to us at the email address below.
          </p>
        </section>

        <section>
          <h2>17. Contact</h2>
          <p>
            The Hall Pass<br />
            Hayward, California, United States<br />
            Email: <a href="mailto:legal@thehallpass.com">legal@thehallpass.com</a>
          </p>
        </section>

        <section className="hp-legal-disclaimer">
          <p>
            <strong>Legal Notice</strong>: These Terms are provided as a
            starting template for a U.S. pre-launch landing page. They are not
            legal advice, and they have not been customized to your specific
            entity structure, operations, or jurisdictions. You should have
            qualified counsel review and tailor this document, including the
            arbitration and indemnification provisions, before relying on it.
          </p>
        </section>
      </main>

      <footer className="hp-legal-footer">
        <Link to="/" className="hp-legal-link">Home</Link>
        <Link to="/privacy" className="hp-legal-link">Privacy Policy</Link>
      </footer>
    </div>
  );
}
